var _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgCtBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 936,
    height: 649,
    viewBox: "0 0 936 649",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 160,
    cy: 489,
    r: 110,
    stroke: "#D0EFCB",
    strokeWidth: 100
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 636,
    cy: 300,
    r: 240,
    stroke: "#F9ECD2",
    strokeWidth: 120
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgCtBottom);
export default __webpack_public_path__ + "static/media/bg-ct-bottom.039d5d0341400503bcb665a1892f2bf6.svg";
export { ForwardRef as ReactComponent };